module.exports = __webpack_public_path__ + "img/404.d592db65.svg";